import React, { useEffect, useMemo, useRef } from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'
import useGame from './stores/useGame.jsx'
import { useFrame } from '@react-three/fiber'

export function Arm(props) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF('/robotArm.glb')
  const { actions } = useAnimations(animations, group)
  const play = useGame((state) => state.play)
  const toggleGas = useGame((state) => state.toggleGas)
  
  materials.Material.emissiveIntensity = 25
  materials.Material.roughness = 0.25
    materials.Material.metalness = 0.75

  nodes.arm.castShadow = true
  nodes.arm.receiveShadow = true

  nodes.SteelCase_Migration_HA_Desk.castShadow = true
  nodes.SteelCase_Migration_HA_Desk.receiveShadow = true

  const animationAction = useRef()

  const animationPlaying = useRef(false) 
  var touchPointsReleased = false

  if(actions['arm_skeleton|arm_skeleton|ArmAction'] != undefined)
  {
    actions['arm_skeleton|arm_skeleton|ArmAction'].play()
    animationAction.current = actions['arm_skeleton|arm_skeleton|ArmAction'].paused
  }

  useEffect(()=>
  {
    if(play === true)
    {
        actions['arm_skeleton|arm_skeleton|ArmAction'].loop = false
        actions['arm_skeleton|arm_skeleton|ArmAction'].clampWhenFinished = true
        actions['arm_skeleton|arm_skeleton|ArmAction'].timeScale = 1
        actions['arm_skeleton|arm_skeleton|ArmAction'].repetitions = 0
        actions['arm_skeleton|arm_skeleton|ArmAction'].paused = false
        actions['arm_skeleton|arm_skeleton|ArmAction'].play()
        
    }

    if(play === false)
        {
        actions['arm_skeleton|arm_skeleton|ArmAction'].loop = false
        actions['arm_skeleton|arm_skeleton|ArmAction'].clampWhenFinished = true
        actions['arm_skeleton|arm_skeleton|ArmAction'].timeScale = -20
        actions['arm_skeleton|arm_skeleton|ArmAction'].repetitions = 0
        actions['arm_skeleton|arm_skeleton|ArmAction'].paused = false
        actions['arm_skeleton|arm_skeleton|ArmAction'].play()
        }

  },[play])  


useFrame((state, delta) => 
  {
        if(actions['arm_skeleton|arm_skeleton|ArmAction'].isRunning() === true)
        {animationPlaying.current = true}

        if(actions['arm_skeleton|arm_skeleton|ArmAction'].isRunning() === false && play === true)
        {
          animationPlaying.current = false
        {
        actions['arm_skeleton|arm_skeleton|ArmAction'].loop = false
        actions['arm_skeleton|arm_skeleton|ArmAction'].clampWhenFinished = true
        actions['arm_skeleton|arm_skeleton|ArmAction'].timeScale = -20
        actions['arm_skeleton|arm_skeleton|ArmAction'].repetitions = 0
        actions['arm_skeleton|arm_skeleton|ArmAction'].paused = false
        actions['arm_skeleton|arm_skeleton|ArmAction'].play()
        }
          toggleGas()
        }

  },[])

  return (
    <group ref={group} {...props} dispose={null}               
              >
      <group name="Scene"               
              >
        <group name="arm_skeleton" position={[0, -0.403, 0.379]} scale={0.987}              
              >
          <skinnedMesh
            name="arm"
            geometry={nodes.arm.geometry}
            material={materials.Material}
            skeleton={nodes.arm.skeleton}
                          castShadow
              receiveShadow
          />
          <primitive object={nodes.Bone}              castShadow
              receiveShadow />
          <primitive object={nodes.Bone011}              castShadow
              receiveShadow />
          <primitive object={nodes.Bone012}              castShadow
              receiveShadow />
          <primitive object={nodes.Bone013}              castShadow
              receiveShadow />
        </group>
        <group
          name="SteelCase_Migration_HA_Desk"
          position={[0, -14, 0]}
          rotation={[-Math.PI, 1.396, 0]}
                        castShadow
              receiveShadow
          scale={-17.419}>
          <group
            name="Steelcase_AM_Desking_HeightAdjustable_Bivi_Base_T-Caste_299002"
            position={[0.004, 0.333, 0.012]}
            rotation={[0, -1.396, -Math.PI]}
                          castShadow
              receiveShadow
            scale={-1}>
            <mesh
              name="Steelcase_AM_Desking_HeightAdjustable_Bivi_Base_T-Caste_dd6002"
              castShadow
              receiveShadow
              geometry={
                nodes['Steelcase_AM_Desking_HeightAdjustable_Bivi_Base_T-Caste_dd6002'].geometry
              }
              material={materials.Mat_SC_AM_Desk_01}
            />
            <mesh
              name="Steelcase_AM_Desking_HeightAdjustable_Bivi_Base_T-Caste_dd6002_1"
              castShadow
              receiveShadow
              geometry={
                nodes['Steelcase_AM_Desking_HeightAdjustable_Bivi_Base_T-Caste_dd6002_1'].geometry
              }
              material={materials.Mat_SC_AM_Desk_02}
            />
            <mesh
              name="Steelcase_AM_Desking_HeightAdjustable_Bivi_Base_T-Caste_dd6002_2"
              castShadow
              receiveShadow
              geometry={
                nodes['Steelcase_AM_Desking_HeightAdjustable_Bivi_Base_T-Caste_dd6002_2'].geometry
              }
              material={materials.Mat_SC_AM_Desk_03}
            />
            <mesh
              name="Steelcase_AM_Desking_HeightAdjustable_Bivi_Base_T-Caste_dd6002_3"
              castShadow
              receiveShadow
              geometry={
                nodes['Steelcase_AM_Desking_HeightAdjustable_Bivi_Base_T-Caste_dd6002_3'].geometry
              }
              material={materials.Mat_SC_AM_Desk_04}
            />
          </group>
        </group>
      </group>
    </group>
  )
}

useGLTF.preload('/robotArm.glb')